import { t } from "@redotech/redo-i18n";
import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
import { defaultChildRoute } from "../legacy-redirects";

export const chargebackSettingsRoutes: PermissionedRouteObject[] = [
  {
    path: "chargebacks",
    handle: {
      get breadcrumb() {
        return t("Chargebacks");
      },
    },
    children: [
      defaultChildRoute("reclaim"),
      {
        path: ":tab",
        lazy: async () => {
          const { ChargebacksSettingsPage } =
            await import("../../../../setting/chargebacks/chargebacks-settings-page");
          return { Component: ChargebacksSettingsPage };
        },
      },
    ],
  },
];
